import { Component, ComponentInterface, h, Host, JSX, Prop } from '@stencil/core';

export type GridColumns = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | '11' | '12' | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

/**
 * @slot - Contents placed within the element
 */
@Component({
  tag: 'wb-grid-col',
  styleUrl: 'grid-col.scss',
  shadow: true,
})
export class GridColComponent implements ComponentInterface {
  /** attribute for grid-col width on mq1 */
  @Prop({ reflect: true, attribute: 'mq1' })
  public mq1?: GridColumns | 'hide';

  /** attribute for grid-col width on mq2 */
  @Prop({ reflect: true, attribute: 'mq2' })
  public mq2?: GridColumns | 'hide';

  /** attribute for grid-col width on mq3 */
  @Prop({ reflect: true, attribute: 'mq3' })
  public mq3?: GridColumns | 'hide';

  /** attribute for grid-col width on mq4 */
  @Prop({ reflect: true, attribute: 'mq4' })
  public mq4?: GridColumns | 'hide';

  /** attribute for grid-col width on mq5 */
  @Prop({ reflect: true, attribute: 'mq5' })
  public mq5?: GridColumns | 'hide';

  /** attribute for grid-col width on mq6 */
  @Prop({ reflect: true, attribute: 'mq6' })
  public mq6?: GridColumns | 'hide';

  /** attribute for grid-col on mq1 for each individual col starting at set col  */
  @Prop({ reflect: true, attribute: 'start-col-mq1' })
  public startColMq1?: GridColumns | 'auto';

  /** attribute for grid-col on mq2 for each individual col starting at set col  */
  @Prop({ reflect: true, attribute: 'start-col-mq2' })
  public startColMq2?: GridColumns | 'auto';

  /** attribute for grid-col on mq3 for each individual col starting at set col */
  @Prop({ reflect: true, attribute: 'start-col-mq3' })
  public startColMq3?: GridColumns | 'auto';

  /** attribute for grid-col on mq4 for each individual col starting at set col  */
  @Prop({ reflect: true, attribute: 'start-col-mq4' })
  public startColMq4?: GridColumns | 'auto';

  /** attribute for grid-col on mq5 for each individual col starting at set col  */
  @Prop({ reflect: true, attribute: 'start-col-mq5' })
  public startColMq5?: GridColumns | 'auto';

  /** attribute for grid-col on mq6 for each individual col starting at set col */
  @Prop({ reflect: true, attribute: 'start-col-mq6' })
  public startColMq6?: GridColumns | 'auto';

  /** apply, if you specificly want to allow overflow-x to be visible */
  @Prop({ reflect: true })
  public allowOverflowX: boolean = false;

  /** apply, if you specificly want the overflow-x to be scrollable */
  @Prop({ reflect: true })
  public scrollOverflowX: boolean = false;

  /** apply, if you specificly want the overflow to be figured out automatically */
  @Prop({ reflect: true })
  public autoOverflow: boolean = false;

  public render(): JSX.Element {
    return (
      <Host class="wb-grid-col">
        <slot />
      </Host>
    );
  }
}
